export const useLineTag = () => {
  /**
   * GTMのLINEタグに商品詳細画面の閲覧イベント送信
   */
  const sendLineViewEvent = (productCode: string) => {
    if (!window.dataLayer) return;
    window.dataLayer.push({ line: null });
    window.dataLayer.push({
      event: 'tlb.LINE_VIEW',
      line: {
        item_id: productCode,
      },
    });
  };

  return { sendLineViewEvent };
};
